import styled from "styled-components"
import Dropzone from "react-dropzone"

import {TextArea} from "@irati/ui/src/FormItem"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import {FormGroup} from "@irati/ui/src/Form"

export const StyledTextArea = styled(TextArea)`
  textarea {
    resize: none;
  }
`

export const StyledDropzone = styled(Dropzone)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: ${({theme}) => theme.border.radius.large};
  background-color: ${({theme}) => theme.colors.greys.grey03};
  border-color: ${({theme}) => theme.colors.greys.grey03};
  height: 146px;
  padding: ${({theme}) => theme.spacing.two};
  cursor: pointer;
`

export const StyledDropzoneFromOutside = styled(Dropzone)`
  display: flex;
  cursor: pointer;
`

export const StyledUploadIcon = styled.img`
  display: block;
  text-align: center;
  margin: 0 auto ${({theme}) => theme.spacing.one};
  height: 50px;
`

export const UploadedImage = styled.img`
  max-height: 100%;
  max-width: 100%;
`

export const StyledFormGroup = styled(FormGroup)`
  &.form-group {
    margin: 0;
    flex: 1;
  }
`

export const StyledIconTooltip = styled(IconTooltip)`
  margin-left: 5px;
  margin-top: 1px;
`
